export default class {
	constructor(idPedido, idItemAta, quantidadeSolicitada, idOrgao) {
		this.idPedido = idPedido
		this.idItemAta = idItemAta
		this.quantidadeSolicitada = quantidadeSolicitada
		this.idOrgao = idOrgao
	}
}
